module.exports = __webpack_public_path__ + "static/media/close.e6b20248.svg";